var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Loader = require('react-loader');
var DashboardWithDataMyGiHistory = require('./layout/dashboardWithDataMyGiHistory.jsx');
var DashboardWithoutDataMyGiHistory = require('./layout/dashboardWithoutDataMyGiHistory.jsx');

var DashboardMyGiHistory = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function() {
        this.props.fetchLatestHpi('GIHistory', this.props.auth.token);

        if($('#alarm-symptom-alert').length > 0){
            this.$modal = new Foundation.Reveal($('#alarm-symptom-alert'), {
                animationIn: "slide-in-down",
                animationOut: "slide-out-down"
            });
            this.$modal.open();

            // shouldn't keep page specific modal/reveal instance and its content through the entirel app life, except for a reasonable reason
            // destory before closed will leave 'is-reveal-open' class on 'html, body', may something else, better avoid doing it yourself
            this.$modal.$element.on('closed.zf.reveal', function(){
                var $element = this.$modal.$element;
                this.$modal.destroy(); // this will set this.$modal.$element to null, so you need cache it before
                $element.remove();
            }.bind(this));
        }
    },

    hasDataLoaded: function(){
        return !this.props.dashboard.isFetching && Object.keys(this.props.dashboard.error).length === 0 && this.props.dashboard.error !== '';
    },

    getAlarmSymptomStr: function(){
        return this.props.dashboard.alarmSymptomResponses.map(function(userResponse){
            return userResponse.text;
        }).join('\n');
    },

    getContent: function(){
        var content = null;

        if(this.hasDataLoaded()){
            if(Object.keys(this.props.dashboard.latestHpi).length){
                content = (
                    <DashboardWithDataMyGiHistory
                        latestHpi={this.props.dashboard.latestHpi}
                        isHpiSent={this.props.dashboard.isHpiSent}
                        clearSendHpiStatus={this.props.clearSendHpiStatus}
                        sendHpi2Doctor={this.props.sendHpi2Doctor}
                        mySpecialist={this.props.specialist.mySpecialist}
                        mySpecialistPractice={this.props.specialist.mySpecialistPractice}
                        showModal={this.props.showModal}
                        clickTracking={this.props.recordDashboardClick} />
                );
            }else{
                content = (
                    <DashboardWithoutDataMyGiHistory clickTracking={this.props.recordDashboardClick} />
                );
            }
        }
        return content;
    },

    render: function(){
        var alarmSymptomStr = this.getAlarmSymptomStr();

        return (
            <div className="content-history content">
                <Loader loaded={this.hasDataLoaded()}>
                    {this.getContent()}
                </Loader>

                {alarmSymptomStr &&
                    <div className="reveal" id="alarm-symptom-alert">
                        <button className="close-button" data-close="" aria-label="Close reveal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h1>Alert!</h1>
                        <p>You have reported the following alarm symptoms:</p>
                        <p className="pre-line"><strong>{alarmSymptomStr}</strong></p>
                        <p className="recommend">We recommend that you discuss this with your doctor as soon as possible.</p>
                        <a className="close" data-close="">Okay</a>
                        <a className="close" data-close="">I already discussed this</a>
                    </div>
                }
            </div>
        );
    }
});

module.exports = DashboardMyGiHistory;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/dashboardMyGiHistory.jsx